export const AnalysisVisitDetail = {
    path: '/analysis/visit/detail/:type',
    name: 'analysis.visit.detail',
    component: () => import('@/views/Analysis/AnalysisVisitDetail.vue'),
    children: [
        {
            path: '/analysis/visit/detail/customer/view/physician/:id',
            name: 'analysis.visit.detail.customer.physician.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'physician'}
        },
        {
            path: '/analysis/visit/detail/customer/view/pharmacy/:id',
            name: 'analysis.visit.detail.customer.pharmacy.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'pharmacy'}
        },
        {
            path: '/analysis/visit/detail/customer/view/wholesaler/:id',
            name: 'analysis.visit.detail.customer.wholesaler.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'wholesaler'}
        },


        {
            path: '/analysis/visit/detail/physician/view/:id',
            name: 'analysis.visit.detail.physician.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'physician'},
        },
        {
            path: '/analysis/visit/detail/pharmacy/view/:id',
            name: 'analysis.visit.detail.pharmacy.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'pharmacy'},
        },
        {
            path: '/analysis/visit/detail/wholesaler/view/:id',
            name: 'analysis.visit.detail.wholesaler.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'wholesaler'},
        },
    ]
}